import { FC, useEffect } from 'react';
import { Box, Divider, Link, Modal, Svg, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';
import { startCase } from 'lodash';

import { analyticsViewRiderContact } from '../../../../api/services/Analytics';
import { actions, Can, subjects } from '../../../../contexts/AbilityContext';
import { formatPhone } from '../../../../utils/helpers/formatPhone';
import { CloseButton } from '../styles';
import { IContact } from '../types';

interface IModal {
  isOpen: boolean;
  onCancel: () => void;
  handleDeleteButton: () => void;
  contact: IContact;
  openEditModal: (boolean) => void;
}

export const ViewModal: FC<IModal> = ({ isOpen, onCancel, handleDeleteButton, contact, openEditModal }) => {
  useEffect(() => {
    isOpen && analyticsViewRiderContact();
  }, [isOpen]);

  return (
    <Modal open={isOpen} data-testid="view-contact-modal">
      <Modal.Title>
        <Box display="flex" alignItems="center">
          {contact.fullName}
          <CloseButton onClick={onCancel}>
            <Svg height="20px" icon="close-outlined" />
          </CloseButton>
        </Box>
      </Modal.Title>
      <Modal.Content>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" flexDirection="column" width="50%">
            <Text>Phone</Text>
            <Text fontWeight={300} textColor="secondaryText">
              {formatPhone(contact.phoneNumber)}
            </Text>
          </Box>
          <Box display="flex" flexDirection="column" width="50%">
            <Text>Email</Text>
            {contact.email ? (
              <Link fontWeight={300} href={`mailto:${contact.email}`}>
                {contact.email}
              </Link>
            ) : (
              <Text fontWeight={300} textColor="secondaryText">
                <i>None specified.</i>
              </Text>
            )}
          </Box>
        </Box>
        <Divider my={5} />
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" flexDirection="column" width="50%">
            <Text>Role</Text>
            <Text fontWeight={300} textColor="secondaryText">
              {startCase(contact.role.replace('_', ' '))}
            </Text>
          </Box>
          <Box display="flex" flexDirection="column" width="50%">
            <Text>Relationship</Text>
            <Text fontWeight={300} textColor="secondaryText">
              {contact.relationship === 'guardian'
                ? 'Parent or Guardian'
                : startCase(contact.relationship) || <i>None specified.</i>}
            </Text>
          </Box>
        </Box>
      </Modal.Content>
      <Modal.Actions>
        <Box display="flex" flex="1" justifyContent="space-between">
          <Can I={actions.delete} a={subjects.rider}>
            <Button color="destructive" onClick={handleDeleteButton} style={{ flexGrow: 0 }}>
              Delete
            </Button>
          </Can>
          <Can I={actions.edit} a={subjects.rider}>
            <Button color="secondary" onClick={() => openEditModal(true)} style={{ flexGrow: 0 }}>
              Edit
            </Button>
          </Can>
        </Box>
      </Modal.Actions>
    </Modal>
  );
};
